$(document).ready(function () {
    $(".js-qty__adjust").click(function () {
    setTimeout(function () {
      $(".btn--secondary.update-cart.cart--button-update").trigger("click");
    }, 500);
  });


$(".js-qty__adjust").click(function () {
    var current_product_id = $(this).closest(".maxorder").attr("productsameid");
    var orderidd = $(this).closest(".maxorder").attr("productid");

    if ($(".plusq" + current_product_id).length < 2) {
     
      var maxorderquantitybackend = $(this)
        .closest(".maxorder")
        .attr("availableqtyback");
      var maxorderquantity = $(this).closest(".maxorder").attr("maxorder");
      if (parseInt(maxorderquantitybackend) < parseInt(maxorderquantity)) {
        $(".cartmes" + orderidd).text("max avaialble limit reached");
        $(this).closest(".maxorder").attr("maxorder", maxorderquantitybackend);
      }
    }

    var idfind = $(this).closest(".maxorder").attr("productid");

    var current_input_qty = $(".thise" + idfind).val();
    // alert(current_input_qty)
    var maxorderquantity = $(this).closest(".maxorder").attr("maxorder");
    var current_product_id = $(this).closest(".maxorder").attr("productsameid");
    var total_qty_c = 0;
    $(".plusq" + current_product_id).each(function () {
      total_qty_c = parseInt(total_qty_c) + parseInt($(this).val());
    });
    var maxorderquantitybackend = $(this)
      .closest(".maxorder")
      .attr("availableqtyback");

    if (
      parseInt(current_input_qty) <= parseInt(maxorderquantitybackend) &&
      parseInt(total_qty_c) <= parseInt(maxorderquantity)
    ) {
      setTimeout(function () {
        $(".btn--secondary.update-cart.cart--button-update").trigger("click");
      }, 3000);
    } else if (
      parseInt(current_input_qty) > parseInt(maxorderquantitybackend) &&
      parseInt(total_qty_c) <= parseInt(maxorderquantity)
    ) {
      var currentvarientclass = $(this).closest(".maxorder").attr("productid");
      $(this).closest(".maxorder").addClass("maxorderreached2");
      var currentvarientid = ".thise" + currentvarientclass;
      $(currentvarientid).val(maxorderquantitybackend);
      setTimeout(function () {
        $(".btn--secondary.update-cart.cart--button-update").trigger("click");
      }, 3000);
    } else {
      var maxorderquantity = $(this).closest(".maxorder").attr("maxorder");

      var thisproductid = $(this).closest(".maxorder").attr("productsameid");
      var current_index = $(this).attr("data-index");

      var currentquantityclass = ".plusq" + thisproductid;
      if ($(currentquantityclass).length > 1) {
        var total2 = 0;
        $(currentquantityclass).each(function () {
          var value = parseInt($(this).val());
          total2 += value;
        });
        var used_other_varinats_qty = 0;
        $(currentquantityclass).each(function () {
          if ($(this).attr("data-index") != current_index) {
            var value = parseInt($(this).val());
            used_other_varinats_qty += value;
          }
        });

        var availableqty = parseInt(maxorderquantity) - total2;

        if (parseInt(availableqty) >= 0) {
          var currentvarientclass = $(this)
            .closest(".maxorder")
            .attr("productid");
          var currentvarientid = ".thise" + currentvarientclass;

          setTimeout(function () {
            $(".btn--secondary.update-cart.cart--button-update").trigger(
              "click"
            );
          }, 3000);
          //}
        } else {
          $(this).closest(".maxorder").addClass("maxorderreached");
          var balance_available =
            parseInt(maxorderquantity) - parseInt(used_other_varinats_qty);

          var currentvarientclass = $(this)
            .closest(".maxorder")
            .attr("productid");
          var currentvarientid = ".thise" + currentvarientclass;
          $(currentvarientid).val(balance_available);
          setTimeout(function () {
            $(".btn--secondary.update-cart.cart--button-update").trigger(
              "click"
            );
          }, 3000);
        }
      }

      if ($(currentquantityclass).length < 2) {
        var currentvarientclass = $(this)
          .closest(".maxorder")
          .attr("productid");
        var currentvarientid = ".thise" + currentvarientclass;
        var currentthisqty = $(currentvarientid).val();
        // alert(currentthisqty)
        setTimeout(function () {
          $(".btn--secondary.update-cart.cart--button-update").trigger("click");
        }, 3000);
        if (parseInt(currentthisqty) > parseInt(maxorderquantity)) {
          var currentvarientclass = $(this)
            .closest(".maxorder")
            .attr("productid");
          var currentvarientid = ".thise" + currentvarientclass;
          $(currentvarientid).val(maxorderquantity);
          $(this).closest(".maxorder").addClass("maxorderreached");
          setTimeout(function () {
            $(".btn--secondary.update-cart.cart--button-update").trigger(
              "click"
            );
          }, 3000);
        }
      }
    }
  });


 $(".js-qty__num").on("blur", function () {
    var current_product_id = $(this).closest(".maxorder").attr("productsameid");
    var orderidd = $(this).closest(".maxorder").attr("productid");

    if ($(".plusq" + current_product_id).length < 2) {
      var maxorderquantitybackend = $(this)
        .closest(".maxorder")
        .attr("availableqtyback");
      var maxorderquantity = $(this).closest(".maxorder").attr("maxorder");
      if (parseInt(maxorderquantitybackend) < parseInt(maxorderquantity)) {
        //  alert("333");
        $(".cartmes" + orderidd).text("max avaialble limit reached");
        // alert(333);
        $(this).closest(".maxorder").attr("maxorder", maxorderquantitybackend);
      }
    }

    //setTimeout(function(){
    var current_input_qty = $(this).val();
    var maxorderquantity = $(this).closest(".maxorder").attr("maxorder");
    var current_product_id = $(this).closest(".maxorder").attr("productsameid");
    var total_qty_c = 0;
    $(".plusq" + current_product_id).each(function () {
      total_qty_c = parseInt(total_qty_c) + parseInt($(this).val());
    });
    var maxorderquantitybackend = $(this)
      .closest(".maxorder")
      .attr("availableqtyback");

    if (
      parseInt(current_input_qty) <= parseInt(maxorderquantitybackend) &&
      parseInt(total_qty_c) <= parseInt(maxorderquantity)
    ) {
      setTimeout(function () {
        $(".btn--secondary.update-cart.cart--button-update").trigger("click");
      }, 3000);
    } else if (
      parseInt(current_input_qty) > parseInt(maxorderquantitybackend) &&
      parseInt(total_qty_c) <= parseInt(maxorderquantity)
    ) {
      var currentvarientclass = $(this).closest(".maxorder").attr("productid");
      $(this).closest(".maxorder").addClass("maxorderreached2");
      var currentvarientid = ".thise" + currentvarientclass;
      $(currentvarientid).val(maxorderquantitybackend);
      setTimeout(function () {
        $(".btn--secondary.update-cart.cart--button-update").trigger("click");
      }, 3000);
    } else {
      var thisproductid = $(this).closest(".maxorder").attr("productsameid");
      var current_index = $(this).attr("data-index");

      var currentquantityclass = ".plusq" + thisproductid;
      if ($(currentquantityclass).length > 1) {
        var total2 = 0;
        $(currentquantityclass).each(function () {
          var value = parseInt($(this).val());
          total2 += value;
        });
        var used_other_varinats_qty = 0;
        $(currentquantityclass).each(function () {
          if ($(this).attr("data-index") != current_index) {
            var value = parseInt($(this).val());
            used_other_varinats_qty += value;
          }
        });

        var availableqty = parseInt(maxorderquantity) - total2;

        //return false;
        if (parseInt(availableqty) >= 0) {
          var currentvarientclass = $(this)
            .closest(".maxorder")
            .attr("productid");
          var currentvarientid = ".thise" + currentvarientclass;

          setTimeout(function () {
            $(".btn--secondary.update-cart.cart--button-update").trigger(
              "click"
            );
          }, 3000);
        } else {
          $(this).closest(".maxorder").addClass("maxorderreached");
          var balance_available =
            parseInt(maxorderquantity) - parseInt(used_other_varinats_qty);

          if (
            $(this).closest(".maxorder").attr("availableqtyback") <
            balance_available
          ) {
            balance_available = $(this)
              .closest(".maxorder")
              .attr("availableqtyback");
          }

          var currentvarientclass = $(this)
            .closest(".maxorder")
            .attr("productid");
          var currentvarientid = ".thise" + currentvarientclass;
          $(currentvarientid).val(balance_available);
          setTimeout(function () {
            $(".btn--secondary.update-cart.cart--button-update").trigger(
              "click"
            );
          }, 3000);
        }
      }
    }

    if ($(currentquantityclass).length < 2) {
      var currentthisqty = $(this).val();
      setTimeout(function () {
        $(".btn--secondary.update-cart.cart--button-update").trigger("click");
      }, 3000);
      if (parseInt(currentthisqty) > parseInt(maxorderquantity)) {
        var currentvarientclass = $(this)
          .closest(".maxorder")
          .attr("productid");
        var currentvarientid = ".thise" + currentvarientclass;
        $(currentvarientid).val(maxorderquantity);
        $(this).closest(".maxorder").addClass("maxorderreached");
        setTimeout(function () {
          $(".btn--secondary.update-cart.cart--button-update").trigger("click");
        }, 3000);
      }
    }
    //  }
    //},1500);
  });


                  });